import React, { useEffect, useState, useRef } from 'react';
type DeferredSectionProps = {
  children: React.ReactNode;
  minHeight?: number;
  triggerEvent?: string;
};
export function DeferredSection({
  children,
  minHeight = 360,
  triggerEvent
}: DeferredSectionProps) {
  const reference = useRef<HTMLDivElement>(null);
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    const element = reference.current;
    if (!element || isReady) return;
    const observer = new IntersectionObserver(entries => {
      if (!entries[0]?.isIntersecting) return;
      setIsReady(true);
      observer.disconnect();
    }, {
      rootMargin: '700px 0px'
    });
    const handleTrigger = () => {
      setIsReady(true);
      observer.disconnect();
    };
    observer.observe(element);
    if (triggerEvent) window.addEventListener(triggerEvent, handleTrigger);
    return () => {
      observer.disconnect();
      if (triggerEvent) window.removeEventListener(triggerEvent, handleTrigger);
    };
  }, [isReady, triggerEvent]);
  return <div ref={reference} className="deferred-section" style={isReady ? undefined : {
    minHeight
  }} data-id="element-54" data-mp="vdpsq4zt51q2">
      {isReady ? children : null}
    </div>;
}